window.videoModal;
window.videoModalButton;
window.videoModal = document.getElementById('video-modal');
window.videoIframe = videoModal ? videoModal.querySelector('iframe') : false;

[].slice.call(document.querySelectorAll('.video-modal-button')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		videoIframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
		videoIframe.setAttribute('allowfullscreen', true);
		videoIframe.src = this.getAttribute('video-src');
        videoModalButton = this;

		Velocity(videoModal, {opacity: [1,0]}, {duration: 300, display: 'block'});

		setTimeout(function() {
			videoModal.querySelector('.close-modal').focus();
			skipLinkToggleDisplay(true);
			setFocus(true, false);
		}, 300);

        videoIframe.setAttribute('title', this.querySelector('h3').innerHTML);
	});
});